import { TableWithStoredSettingsAndLayoutSettings } from '@Components/Tables/TableWithStoredSettingsAndLayoutSettings';
import { MAILING_API } from '@Constants/backendConstants';
import {
    type ApiSetting,
    Enum,
    EnumFrontendLayoutSetting,
    EnumMailingSettingGroup,
    EnumMailingSettingModule,
} from '@Model';
import { useServerListApi } from '@synqo/frontend-component-library';
import { useCallback } from 'react';
import { useClientNavigate } from '../../../../Routing/useClientNavigate';

export interface FrameListSettingsProps {
    name: string;
}

export type ApiEmailSetting<TSettingNames extends Enum> = ApiSetting<
    TSettingNames,
    EnumMailingSettingGroup,
    EnumMailingSettingModule
>;

const columns = [{ name: 'label', label: 'Bezeichnung' }];

export function FrameListEmailSettings<TSettingNames extends Enum>(props: FrameListSettingsProps) {
    const navigate = useClientNavigate();
    const module = useServerListApi<ApiEmailSetting<TSettingNames>>({
        path: `${MAILING_API}/settings/${props.name}`,
    });

    const onSelect = useCallback(
        (setting: ApiEmailSetting<TSettingNames>) => {
            navigate(`../${setting.setting_group}`);
            return true;
        },
        [navigate],
    );

    return (
        <TableWithStoredSettingsAndLayoutSettings
            layoutSettingsContext={EnumFrontendLayoutSetting.EmailSettingsTableLayout}
            name={props.name + 'List'}
            columns={columns}
            loader={module.loadPage}
            onSelect={onSelect}
            canCreate={false}
            fullSize
            useOnClickNavigation
        />
    );
}
